import { observer } from "mobx-react";
import React from "react";
import { useBetween } from "use-between";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import ModalInformationReport from "@dropDesk/presentation/components/modals/modal_information_report";
import { ICONS_DROPDESK } from "@dropDesk/storage/icons/icons.d";
import {
    useModalsReportTicketComparative
} from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket_comparative/ui/modals/handle_change_visible";

const ModalsReportTicketComparative = observer(({
    loading,
    exportHtml,
}: {
    loading: boolean;
    exportHtml: () => void;
}) => {
    const {
        visibleModalExportHtml,
        setVisibleModalExportHtml,
        visibleModalInformationReport,
        setVisibleModalInformationReport,
        textHeaderModalInformationReport,
        textInformationHeader,
        textInformationBody,
    } = useBetween(useModalsReportTicketComparative);

    return (
        <>
            <ModalInformationReport
                open={visibleModalInformationReport}
                onRequestClose={() => {
                    setVisibleModalInformationReport(false);
                }}
                textHeaderModal={textHeaderModalInformationReport}
                textButton={'OK'}
                onRequestSave={async () => {
                    setVisibleModalInformationReport(false);
                }}
                textInformationHeader={textInformationHeader}
                textInformationBody={textInformationBody}
                loading={loading}
            />
            <ModalInformation
                open={visibleModalExportHtml}
                onRequestClose={() => {
                    setVisibleModalExportHtml(false);
                }}
                textHeaderModal={'Exportar relatório'}
                textButton={'Exportar'}
                onRequestSave={async () => {
                    exportHtml();
                    setVisibleModalExportHtml(false);
                }}
                nameIcon={ICONS_DROPDESK.documentOutline}
                sizeIcon={115}
                textInformation={'Deseja realmente exportar o relatório comparativo para um documento, que abra em todo navegador?'}
                loading={loading}
            />
        </>
    );
});

export default ModalsReportTicketComparative;
